(function () {
  const productList = () => {
    const filterBtn = document.querySelector(".product-list__filter-btn");
    const filterPop = document.querySelector(".product-list__filter");
    const filterClose = document.querySelector(".product-list__filter-close");
    const showResult = document.querySelector(".product-list__show-results");
    if (filterBtn) {
      filterBtn.addEventListener("click", () => {
        filterPop.classList.add("product-list__filter--active");
        scrollSet.otherLenisScroll(".product-list__filter-body", true);
      });
    }
    if (filterClose) {
      filterClose.addEventListener("click", () => {
        filterPop.classList.remove("product-list__filter--active");
        scrollSet.otherLenisScroll(".product-list__filter-body", false);
      });
    }
    if (showResult) {
      showResult.addEventListener("click", () => {
        filterPop.classList.remove("product-list__filter--active");
        scrollSet.otherLenisScroll(".product-list__filter-body", false);
      });
    }
    const accordian = document.querySelectorAll(".product-list__accordian");
    if (accordian) {
      accordian.forEach((btn) => {
        const accordianWrap = btn.closest(".product-list__filter-wrap");
        const accordianTxt = btn.querySelector(".visually-hidden");
        btn.addEventListener("click", () => {
          btn.classList.toggle("product-list__accordian--active");
          accordianWrap.classList.toggle("product-list__filter-wrap--active");
          if (
            accordianWrap.classList.contains(
              "product-list__filter-wrap--active"
            )
          ) {
            accordianTxt.textContent = "close";
          } else {
            accordianTxt.textContent = "open";
          }
        });
      });
    }
  };

  document.addEventListener("shopify:section:load", productList);
  productList();
})();
